import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { authRedirectGuard } from '@guards/auth-redirect.guard';

export const routes: Routes = [
  // Keycloak OAuth2 callback – no guard, must sit before all other routes
  {
    path: 'auth/callback',
    data: { headerType: '', disablePadding: true },
    loadComponent: () => import('./features/auth/pages/callback/callback').then((m) => m.Callback),
  },

  // Data processing consent – no guard, reachable by authenticated users before consent is given.
  // `noHeader` renders no header at all: the logged header's sidebar/user-menu calls would 403 with
  // consent_required until the user accepts.
  {
    path: 'consent',
    data: { headerType: '', disablePadding: true, noHeader: true },
    loadComponent: () => import('./features/auth/pages/consent/consent').then((m) => m.Consent),
  },

  // Public sign-up – no guard, reachable before any account/token exists. `hideHeader` keeps the
  // authenticated shell (sidebar/user-menu) off this token-less page so it fires no 401 calls.
  // `scrollable` makes the app shell's <main> scroll (it is `overflow: hidden` by default above
  // 1276px, which otherwise clips the tall form on desktop).
  {
    path: 'sign-up',
    data: { headerType: '', disablePadding: true, hideHeader: true, scrollable: true },
    loadComponent: () => import('./features/auth/pages/sign-up/sign-up').then((m) => m.SignUp),
  },

  {
    path: 'access-denied',
    data: { headerType: '', disablePadding: true },
    loadComponent: () =>
      import('./features/errors/pages/access-denied/access-denied').then((m) => m.AccessDenied),
  },

  {
    path: 'landing',
    canActivate: [authGuard],
    loadChildren: () => import('./features/general/general.routes').then((m) => m.GENERAL_ROUTES),
  },
  {
    path: 'resources',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/resources/resources.routes').then((m) => m.RESOURCES_ROUTES),
  },

  // Redirect root to the user's preferred landing route, or / by default
  { path: '', pathMatch: 'full', canActivate: [authRedirectGuard], children: [] },

  { path: '**', redirectTo: 'resources' },
];
